import { BaseRequest } from "../../../base/request/BaseRequest";

/** Una asignación registro→lote dentro de `AsignarLotesRequest`. */
export type AsignacionLoteItem = {
  /** Registro del análisis a asignar. */
  registroId: string;
  /** Lote real del sistema. */
  loteId: string;
};

/** Request de `POST /fertilizacion/{analisisId}/asignar-lotes`: asigna a mano el
 *  lote de uno o varios registros de un mismo análisis, en una sola llamada
 *  transaccional (todo o nada). */
export type AsignarLotesRequest = BaseRequest & {
  /** Asignaciones registro→lote a aplicar. */
  asignaciones: AsignacionLoteItem[];
};

/** Crea un request de asignación vacío. */
export const fx_createAsignarLotesRequestEmpty = (): AsignarLotesRequest => {
  return { asignaciones: [] };
};
